<!-- Показывает ПЛАН, ФАКТ или их компактное сравнение в таблице заказов. -->
<template>
  <div class="order-plan-fact-cell">
    <div v-if="plan" class="order-plan-fact-cell__line">
      <span>План</span>
      <strong :class="planTone">{{ formatRub(plan.result) }}</strong>
    </div>
    <div v-if="fact" class="order-plan-fact-cell__line">
      <span>Факт</span>
      <strong :class="profitTone">{{ formatRub(fact.profit) }}</strong>
    </div>
    <div v-if="fact" class="order-plan-fact-cell__hint">
      Расходы {{ formatRub(fact.expenses_total) }}
    </div>
    <span v-if="!plan && !fact" class="order-plan-fact-cell__empty">—</span>
  </div>
</template>

<script>
import { formatBigNumber } from "@/utils/numberUtils";

export default {
  name: "OrderPlanFactCell",

  props: {
    value: { type: Object, default: null },
    mode: {
      type: String,
      default: "combined",
      validator: (value) => ["plan", "fact", "combined"].includes(value),
    },
  },

  computed: {
    plan() {
      return this.mode === "fact"
        ? null
        : this.mode === "plan"
          ? this.value
          : this.value?.plan;
    },
    fact() {
      return this.mode === "plan"
        ? null
        : this.mode === "fact"
          ? this.value
          : this.value?.fact;
    },
    planTone() {
      return this.valueTone(this.plan?.result);
    },
    profitTone() {
      return this.valueTone(this.fact?.profit);
    },
  },

  methods: {
    valueTone(value) {
      const number = Number(value);
      if (!Number.isFinite(number) || number === 0) return "";
      return number > 0
        ? "order-plan-fact-cell__value--positive"
        : "order-plan-fact-cell__value--negative";
    },
    formatRub(value) {
      if (value === null || value === undefined || value === "") return "—";
      return `${formatBigNumber(value)} ₽`;
    },
  },
};
</script>

<style scoped>
.order-plan-fact-cell {
  display: flex;
  min-width: 150px;
  flex-direction: column;
  gap: 3px;
  font-variant-numeric: tabular-nums;
}

.order-plan-fact-cell__line {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  font-size: 13px;
}

.order-plan-fact-cell__line > span,
.order-plan-fact-cell__hint,
.order-plan-fact-cell__empty {
  color: #6b7280;
}

.order-plan-fact-cell__line > strong {
  font-weight: 600;
  white-space: nowrap;
}

.order-plan-fact-cell__hint {
  font-size: 11px;
  text-align: right;
}

.order-plan-fact-cell__value--positive {
  color: #047a69;
}

.order-plan-fact-cell__value--negative {
  color: #b42318;
}
</style>
